import React from "react";
import cx from "classnames";
import { getWarehouseClass } from "../../utils/getWarehouseClass";
import classNames from 'classnames';
import { RouteElementType } from '../../utils/utils';
import { getDaysUntilPickupAt } from '../../utils/getTransitCounterLevel';

export const Marker = ({ order, routeOrders, onClick = null, onContextMenuClick = null, routeId, planningColor = null }) => {
    const {
        sender: {
            maxWarehouseDays
        },
        onWarehouseFrom,
        pickupAt,
    } = order;

    routeOrders = routeOrders.filter((element) => element.type === RouteElementType.ROUTE_ORDER)

    const routeOrder = routeOrders.find(routeOrder => routeOrder.order.id === order.id);

    const orderLocationBackgroundColor = (order) => {
        if(routeOrder) {
          return 'map-marker-selected';
        }

      const warehouseLocation = 3;
      const daysUntilPickupAt = getDaysUntilPickupAt(order);

      if (order.statusId === warehouseLocation) {
        return 'map-marker-warehouse';
      }

      if (daysUntilPickupAt === null) {
        return 'map-marker-default';
      }

      if (daysUntilPickupAt > 3) {
        return 'map-marker-transit-upcoming';
      }

      if (daysUntilPickupAt === 3) {
        return 'map-marker-transit-future';
      }

      if (daysUntilPickupAt === 2) {
        return 'map-marker-transit-eta-2-3d';
      }

      if (daysUntilPickupAt === 1) {
        return 'map-marker-transit-eta-1d';
      }

      if (daysUntilPickupAt === 0) {
        return 'map-marker-transit-today';
      }

      return 'map-marker-default';
    }

    const orderDeliveryClass = (order) => {
        if (!routeOrder) {
          return orderLocationBackgroundColor(order);
        }

        switch (order.deliveryConfirmations.filter((confirmation) => confirmation.routeId === routeId)[0]?.status) {
            case 'pending':
                return 'map-marker-pending';
            case 'confirmed':
                return 'map-marker-confirmed';
            case 'canceled_by_customer':
            case 'canceled_by_sender':
            case 'canceled_by_admin':
                return 'map-marker-cancelled';
            default:
                return orderLocationBackgroundColor(order);
        }
    }

    const text = (routeOrder ? routeOrders.findIndex(({ order: o }) => o.id === order.id) + 1 : '');
    const date = pickupAt ? new Date(pickupAt) : new Date();

    const handleClick = onClick ? () => onClick(order) : undefined;
    const handleRightClick = onContextMenuClick ? (event) => onContextMenuClick() : undefined;

    const markerClass = cx(
        'map__marker',
        getWarehouseClass(onWarehouseFrom, maxWarehouseDays, 'map__marker', date),
        { 'map__marker--selected': routeOrder },
        orderDeliveryClass(order),
        { 'map-marker-is-urgent': order.isUrgent },
    )

    const getOrderIconClass = (order) => {
      if (order.isExchange) {
        return 'bx-shuffle';
      }

      if (order.type === 'return') {
        return 'bx-undo';
      }

      return null;
    };

    const badgeIcon = getOrderIconClass(order);
    const showBadge = badgeIcon && (order.isExchange || order.type === 'return');

    // Planning mode: tint warehouse points with their tier color (expanded address
    // groups render through this DOM marker, not the WebGL layer). Selected/route
    // markers keep their existing styling.
    const planningStyle = (planningColor && !routeOrder)
        ? { backgroundColor: planningColor, borderColor: planningColor }
        : undefined;

    return (
        <div className="map__marker-container">
            <div
                className={markerClass}
                style={planningStyle}
                {...(handleClick && { onClick: handleClick })}
                {...(handleRightClick && { onContextMenu: handleRightClick })}
            >
                {text || null}
                {showBadge && (
                  <div className="map__marker-badge">
                    <i className={classNames('bx', badgeIcon)} />
                  </div>
                )}
            </div>
        </div>
    );
};
